var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.36305 7.43238C3.38796 7.45912 3.41287 7.45912 3.43779 7.45912H3.4627C3.48761 7.45912 3.48761 7.45912 3.51252 7.45912C3.53743 7.45912 3.53743 7.45912 3.56234 7.45912H3.58725C3.61216 7.45912 3.63707 7.43238 3.63707 7.43238L5.65487 5.90823C5.75451 5.82802 5.80433 5.66758 5.70469 5.53388C5.60504 5.40019 5.48049 5.37345 5.35593 5.4804L3.73672 6.71041V0.560362C3.73672 0.399926 3.63707 0.292969 3.48761 0.292969C3.33814 0.292969 3.2385 0.399926 3.2385 0.560362V6.71041L1.61928 5.4804C1.49472 5.40019 1.34526 5.42693 1.27053 5.53388C1.24561 5.58736 1.2207 5.64084 1.2207 5.69432C1.2207 5.77454 1.24561 5.85476 1.32035 5.90823L3.36305 7.43238Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75089 8.84766H0.24911C0.0996441 8.84766 0 8.95461 0 9.11505C0 9.27549 0.0996441 9.38244 0.24911 9.38244H6.75089C6.90036 9.38244 7 9.27549 7 9.11505C7 8.95461 6.87545 8.84766 6.75089 8.84766Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.f4f2832db1f419d42306c220863c80a6.svg";
export { ForwardRef as ReactComponent };